import { render, staticRenderFns } from "./empty-protected-layout.vue?vue&type=template&id=edd1a72e"
import script from "./empty-protected-layout.vue?vue&type=script&lang=js"
export * from "./empty-protected-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports